
















import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    tags: { type: Array, required: true },
    selectedTags: { type: Array, required: true },
    column: { type: Boolean, default: false }
  },

  methods: {
    isTagSelected(tagId: number): boolean {
      return !!this.selectedTags.find(t => t.id === tagId)
    }
  }
})
